import { Field } from '../../libs/gs-component-form';
import { FormColumn, FormRow } from '@xo-union/tk-component-form-grid';
import { Subhead } from '@xo-union/tk-ui-typography';
import { Field as FormikField } from 'formik';
import React from 'react';

import styles from './style.scss';

const NameFormSection: React.FC = () => {
  return (
    <>
      <div className={styles.group}>
        <Subhead className={styles.subhead}>Your Information</Subhead>
        <FormRow>
          <FormColumn md>
            <FormikField name="firstName" label="First Name" component={Field} data-testid="first-name" />
          </FormColumn>
          <FormColumn md>
            <FormikField name="lastName" label="Last Name" component={Field} data-testid="last-name" />
          </FormColumn>
        </FormRow>
      </div>
      <div className={styles.group}>
        <Subhead className={styles.subhead}>Your Partner's Information</Subhead>
        <FormRow>
          <FormColumn md>
            <FormikField name="fianceFirstName" label="First Name" component={Field} data-testid="fiance-first-name" />
          </FormColumn>
          <FormColumn md>
            <FormikField name="fianceLastName" label="Last Name" component={Field} data-testid="fiance-last-name" />
          </FormColumn>
        </FormRow>
      </div>
    </>
  );
};

export default NameFormSection;
